// export const URLS = "http://49.13.202.68:5001";
// export const URLS = "https://api.ilo2025.com";
// export const URLS = "http://5.189.173.236:5003";
// export const URLS = "http://localhost:5001";
export const URLS = "https://talent.insa.gov.et";

